import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="mt-24 bg-[#181615] text-stone-300">
    <div className="mx-auto flex max-w-7xl flex-col gap-6 px-4 py-14 sm:px-6 md:flex-row md:items-end md:justify-between lg:px-12">
      <div>
        <img src="/nailora-logo.webp" alt="Nailora" className="h-10 w-auto" />
        <p className="mt-2 max-w-sm text-sm text-stone-400">Where nail techs get found and help each other grow. Every profile is verified through Instagram.</p>
      </div>
      <div className="flex gap-8 text-sm">
        <Link to="/explore" data-testid="footer-explore" className="hover:text-white">Find a tech</Link>
        <Link to="/community" data-testid="footer-community" className="hover:text-white">Community</Link>
      </div>
    </div>
  </footer>
);
